import React from "react";
import Counterapp from "./counterApp.component";
import Login from "./login.component";
import { Routes, Route } from "react-router-dom"
function App() {
  return(
    <>
      <Routes>
        <Route path="" element={ <Login/> } />
        <Route path="/counter" element={ <Counterapp/> } />
      </Routes>
    </>
  )
}

export default App;
